import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { SetPasswordPage } from '@/features/set-password/SetPasswordPage';

export const Route = createFileRoute('/_public/set-password')({
  validateSearch: z.object({
    token: z.string().optional(),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useSearch();
  return <SetPasswordPage token={token ?? ''} />;
}
